import { z } from "zod"

export const billingStatusSchema = z.enum([
  "controlado",
  "liquidado",
  "facturado",
  "cerrado",
])

export type BillingStatus = z.infer<typeof billingStatusSchema>

// null in DB is read as "pendiente" in the frontend
export const BILLING_STATUS_LABELS: Record<BillingStatus | "pendiente", string> = {
  pendiente:  "Pendiente",
  controlado: "Controlado",
  liquidado:  "Liquidado",
  facturado:  "Facturado",
  cerrado:    "Cerrado",
}

export const billingStatusUpdateSchema = z.object({
  billingStatus: billingStatusSchema.nullable(),
})

export type BillingStatusUpdate = z.infer<typeof billingStatusUpdateSchema>
